import React from "react";

import type { NapiV2Ticket } from "@app/types/napi-v2-tickets-types";

import { GooglePayTicket } from "../../../app-wallet-ticket";

interface Props {
  ticket: NapiV2Ticket;
  onError: () => void;
}

export const DownloadGooglePayTicket: React.FC<Props> = ({
  ticket,
  onError
}) => {
  return (
    <GooglePayTicket
      transit_object_jwt={ticket.urls.transit_object_jwt!}
      ticket_id={ticket.id}
      onError={onError}
    />
  );
};
